import React, { useState } from 'react';
import {HtmlParse} from 'utils';
import Ingredients from '../Ingredients';
import Allergens from '../Allergens';
import Recipes from '../Recipes';
import PropTypes from 'prop-types';

const Description = (props) => {
    const {product} = props;
    const description = product.description;
    const technical = props.technical;

    const [tab, setTab] = useState(description ? description : technical);

    const change = (_tab) => {
        setTab(_tab)
    }

    return(
        <div className="product-description">
            {(description || technical) && <div className="product-description-header">
                {description && <h3 className={'product-description-title' + ((tab === description) ? ' active' : '')} onClick={() => change('description')}>Información del producto</h3>}
                {technical && <h3 className={'product-description-title' + ((tab === technical) ? ' active' : '')} onClick={() => change('technical')}>Ficha Técnica</h3>}
            </div>}
            {(description || technical) && <div className="product-description-content">{HtmlParse(tab)}</div>}

            {product['Ingredientes'] && <Ingredients product={product}/>}
            {product['Trazas'] && <Allergens product={product} />}
            {product['Receta'] && <Recipes product={product} />}
        </div>

    )
}

Description.propTypes = {
    description: PropTypes.string,
    technical: PropTypes.string
}
export default Description;
